/* HomePlunge VSL lightbox.

   Why this exists: 16 of the 17 photos on this page sat inside no link and had
   no handler, so every click on them was a dead click. Session recordings were
   full of people tapping product shots and getting nothing.

   The overlay is built on first open, not on page load. This page is already
   359 requests and 3 MB; a gallery nobody opens should cost nothing. */
(function () {
  var SEL = '.hpv img:not(.hpv__badge):not(.hpv__mark)';
  var MIN = 120;                    // ignore icons and hairline decorations
  var lb = null, imgEl, capEl, cntEl, prevBtn, nextBtn, closeBtn;
  var items = [], at = 0, lastFocus = null, scrollY = 0;

  function collect() {
    items = Array.prototype.filter.call(document.querySelectorAll(SEL), function (im) {
      // Ancestors only. closest() would otherwise match the role="button" that
      // this script puts on the image itself, so the second scan emptied the set.
      var p = im.parentElement;
      if (p && p.closest('a, button, [role="button"]')) return false;   // already does something
      var r = im.getBoundingClientRect();
      var w = r.width || im.naturalWidth || 0;
      return w >= MIN;
    });
    return items.length;
  }

  // Shopify serves resized variants off the same URL, so ask for a big one.
  function large(src) {
    if (!src) return src;
    if (src.indexOf('cdn.shopify.com') === -1 && src.indexOf('/cdn/shop/') === -1) return src;
    var clean = src.replace(/([?&])width=\d+/, '$1width=1600');
    if (clean === src) clean = src + (src.indexOf('?') === -1 ? '?' : '&') + 'width=1600';
    return clean;
  }

  function build() {
    lb = document.createElement('div');
    lb.className = 'hpvlb';
    lb.setAttribute('role', 'dialog');
    lb.setAttribute('aria-modal', 'true');
    lb.setAttribute('aria-label', 'Photo viewer');
    lb.innerHTML =
      '<button type="button" class="hpvlb__btn hpvlb__close" aria-label="Close photo viewer">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"><path d="M6 6l12 12M18 6L6 18"/></svg></button>' +
      '<button type="button" class="hpvlb__btn hpvlb__prev" aria-label="Previous photo">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M15 5l-7 7 7 7"/></svg></button>' +
      '<button type="button" class="hpvlb__btn hpvlb__next" aria-label="Next photo">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 5l7 7-7 7"/></svg></button>' +
      '<figure class="hpvlb__fig">' +
        '<img class="hpvlb__img" alt="">' +
        '<figcaption class="hpvlb__cap"></figcaption>' +
        '<span class="hpvlb__count" aria-live="polite"></span>' +
      '</figure>';
    document.body.appendChild(lb);
    imgEl = lb.querySelector('.hpvlb__img');
    capEl = lb.querySelector('.hpvlb__cap');
    cntEl = lb.querySelector('.hpvlb__count');
    prevBtn = lb.querySelector('.hpvlb__prev');
    nextBtn = lb.querySelector('.hpvlb__next');
    closeBtn = lb.querySelector('.hpvlb__close');

    prevBtn.addEventListener('click', function (e) { e.stopPropagation(); go(-1); });
    nextBtn.addEventListener('click', function (e) { e.stopPropagation(); go(1); });
    closeBtn.addEventListener('click', close);
    // Backdrop closes; the photo itself does not, or people close it by accident.
    lb.addEventListener('click', function (e) { if (e.target === lb || e.target.classList.contains('hpvlb__fig')) close(); });

    var x0 = null;
    lb.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
    lb.addEventListener('touchend', function (e) {
      if (x0 === null) return;
      var dx = e.changedTouches[0].clientX - x0;
      if (Math.abs(dx) > 45) go(dx < 0 ? 1 : -1);
      x0 = null;
    }, { passive: true });
  }

  function show(i) {
    if (!items.length) { close(); return; }
    at = ((i % items.length) + items.length) % items.length;
    var cur = items[at];
    if (!cur) { close(); return; }
    var src = cur.currentSrc || cur.src;
    imgEl.src = large(src);
    imgEl.alt = cur.alt || '';
    capEl.textContent = cur.alt || '';
    cntEl.textContent = (at + 1) + ' of ' + items.length;
    var many = items.length > 1;
    prevBtn.hidden = !many; nextBtn.hidden = !many;
    // Warm the neighbours so next/prev feels instant.
    [at + 1, at - 1].forEach(function (n) {
      var it = items[(n + items.length) % items.length];
      if (it) { var p = new Image(); p.src = large(it.currentSrc || it.src); }
    });
  }
  function go(d) { show(at + d); }

  function open(i) {
    if (!lb) build();
    lastFocus = document.activeElement;
    scrollY = window.scrollY;
    document.body.style.position = 'fixed';
    document.body.style.top = -scrollY + 'px';
    document.body.style.width = '100%';
    show(i);
    lb.classList.add('is-open');
    closeBtn.focus();
    document.addEventListener('keydown', onKey);
  }

  function close() {
    if (!lb) return;
    lb.classList.remove('is-open');
    document.removeEventListener('keydown', onKey);
    document.body.style.position = '';
    document.body.style.top = '';
    document.body.style.width = '';
    window.scrollTo(0, scrollY);
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  function onKey(e) {
    if (e.key === 'Escape') { e.preventDefault(); close(); return; }
    if (e.key === 'ArrowRight') { e.preventDefault(); go(1); return; }
    if (e.key === 'ArrowLeft') { e.preventDefault(); go(-1); return; }
    if (e.key === 'Tab') {
      // Keep focus inside the dialog, which is what aria-modal promises.
      var f = [closeBtn, prevBtn, nextBtn].filter(function (b) { return !b.hidden; });
      var i = f.indexOf(document.activeElement);
      e.preventDefault();
      f[(i + (e.shiftKey ? f.length - 1 : 1)) % f.length].focus();
    }
  }

  function wire() {
    if (!collect()) return;
    items.forEach(function (im, i) {
      if (im.dataset.hpvlb) return;
      im.dataset.hpvlb = '1';
      im.addEventListener('click', function (e) {
        e.preventDefault();
        var k = items.indexOf(im);
        if (k === -1) { collect(); k = items.indexOf(im); }
        if (k !== -1) open(k);
      });
      // A photo that opens a viewer is a control, so it needs to act like one.
      if (!im.hasAttribute('tabindex')) im.setAttribute('tabindex', '0');
      im.setAttribute('role', 'button');
      im.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          var k = items.indexOf(im);
          if (k === -1) { collect(); k = items.indexOf(im); }
          if (k !== -1) open(k);
        }
      });
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', wire);
  else wire();
  // Photos further down arrive with lazy loading, so re-scan once things settle.
  window.addEventListener('load', function () { setTimeout(wire, 800); });
})();
